<template>
  <div
    :class="Loading ? 'disable border rounded' : 'border rounded'"
    style="position: relative;"
  >
    <table class="table table-sm table-hover w-100">
      <thead>
        <tr>
          <th class="text-center" colspan="2">
            Order contact info
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right w-35">
            <strong>Firstname:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.firstName"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Lastname:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.lastName"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Company name / Address 1:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.address1"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Address 2:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.address2"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Floor / Room / Suite:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.coname"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>City:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.city"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>State:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.state"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Zip:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.zip"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Day phone:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.dayphone"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Evening phone:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.eveningphone"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Email:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.email"
            />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <button
              type="button"
              style="display: block; margin: 0 auto;"
              class="btn btn-primary"
              @click="submit"
            >
              Update order address
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="centered-spinner" v-if="Loading">
      <a-spin />
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderContactInfo",
  data() {
    return {
      Loading: false,
    };
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
  methods: {
    submit() {
      this.Loading = true;
      const orderAddressRequest = {
        firstName: this.order.firstName,
        lastName: this.order.lastName,
        coname: this.order.coname,
        address1: this.order.address1,
        address2: this.order.address2,
        city: this.order.city,
        state: this.order.state,
        zip: this.order.zip,
        dayphone: this.order.dayphone,
        eveningphone: this.order.eveningphone,
        email: this.order.email,
        orderId: this.order.orderId,
      };
      this.$store
        .dispatch("orderDetails/updateOrderAddress", orderAddressRequest)
        .then((data) => {
          alert(data);
        })
        .finally(() => {
          this.Loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.w-35 {
  width: 35%;
}
.w-65 {
  width: 65%;
}
.centered-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
table{
  margin-bottom: 0px;
  border: solid grey 0.5px;
}
td {
  border: solid grey 0.5px;
}
</style>
